import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../../services/admin';

@Component({
  selector: 'app-med-par-pharmacie',
  templateUrl: './med-par-pharmacie.component.html',
  styleUrls: ['./med-par-pharmacie.component.scss']
})
export class MedParPharmacieComponent implements OnInit {
  nom_p: string = "";
  id: number;
  size:number=10;
  mode_pharmacie: number = 1;
  motCleMed:String="";
  pages:Array<number>;
  currentPage : number=1;
  mode_pharmacie_childre:number;
  pagesCommande:Array<number>;
  pagesBsm:Array<number>;
 pageStock:any;
 pageStock_ANT:any;
 pageStock_ANS:any;
 mode_p:number;
  constructor(public activatedRoute: ActivatedRoute,public adminService: AdminService, private router: Router) {
    this.id = activatedRoute.snapshot.params['id'];

    if (this.id == 1) {
      //load liste anosy
      this.nom_p = "Anosy";
      this.mode_pharmacie_childre=1;
      this.listStockClient_ANS();
    } else if (this.id == 2) {
      //load liste anosy
      this.nom_p = "Tsiazotafo";
      this.mode_pharmacie_childre=2;
    //  this.mode_p=2;
      this.listStockClient_TSZ();
    } else {
      //load liste anosy
      this.nom_p = "Antaninarenina";
      this.mode_pharmacie_childre=3;      
      this.listStockClient_ANT();
    }
  }

  ngOnInit() {
   
  }

  open(id_p: number) {
    if (id_p == 1) {
      this.mode_pharmacie = 1;
    } else if (id_p == 2) {
      this.mode_pharmacie = 2;
    }
  }

//mm Faratina
  listStockClient_TSZ(){ 
    this.adminService.getStockClientPharmacieByMcLc(this.motCleMed,"MDC" , "TSZ",this.currentPage, this.size)
    .subscribe(data => {
        this.pageStock= data;
       // this.pages = new Array(data.totalPages);
       if (data && data[0] && data[0].infoEnregistrement.totalPages)
          this.pages = new Array(data[0].infoEnregistrement.totalPages);
        else this.pages = new Array(0);
        console.log(data);
      }, err => {
        console.log(err);
      });
  }

  //mm Bako
  listStockClient_ANT(){ 
    this.adminService.getStockClientPharmacieByMcLc(this.motCleMed,"MDC" , "MDC",this.currentPage, this.size)
    .subscribe(data => {
        this.pageStock_ANT= data;
       // this.pages = new Array(data.totalPages);
       if (data && data[0] && data[0].infoEnregistrement.totalPages)
          this.pages = new Array(data[0].infoEnregistrement.totalPages);
        else this.pages = new Array(0);
        console.log(data);
      }, err => {
        console.log(err);
      });
  }


  //mm Zo aosy
  listStockClient_ANS(){ 
    this.adminService.getStockClientPharmacieByMcLc(this.motCleMed,"MDC" , "AEP",this.currentPage, this.size)
    .subscribe(data => {
        this.pageStock_ANS= data;
       // this.pages = new Array(data.totalPages);
       if (data && data[0] && data[0].infoEnregistrement.totalPages)
          this.pages = new Array(data[0].infoEnregistrement.totalPages);
        else this.pages = new Array(0);
        console.log(data);
      }, err => {
        console.log(err);
      });
  }

  chercherMed(){  
    if (this.id == 1) {
      //load liste anosy
      this.listStockClient_ANS();
    } else if (this.id == 2) {
      //load liste anosy      
      this.listStockClient_TSZ();
    } else {
      //load liste anosy
      this.listStockClient_ANT();
    }
  }

  
  gotoPage(i:number) {

    if (this.id == 1) {
      //load liste anosy
      if(i<1)return;
    if(i>this.pages.length)return;
    this.currentPage=i;
    this.listStockClient_ANS();
    
    } else if (this.id == 2) {
      //load liste anosy     
      if(i<1)return;
      if(i>this.pages.length)return;
      this.currentPage=i;
      this.listStockClient_TSZ();
    } else {
      //load liste anosy
      if(i<1)return;
      if(i>this.pages.length)return;
      this.currentPage=i;
      this.listStockClient_ANT();
    }
    
  }

}
